import React, { useEffect, useState ,useCallback} from 'react';
import '../styles/Documents.css';

const GenericDocument = ({
    title,
    fetchData,
    deleteFunc,
    viewFunc,
    downloadFunc,
    refreshTrigger
}) => {
    const [documents, setDocuments] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // const loadData = async () => {
    //     try {
    //         setLoading(true);
    //         setError(null);
    //         const data = await fetchData();
    //         setDocuments(data);
    //     } catch (err) {
    //         console.error("Failed to fetch documents", err);
    //         setError("אירעה שגיאה בטעינת המסמכים");
    //     } finally {
    //         setLoading(false);
    //     }
    // };
    const loadData = useCallback(async () => {
        try {
            setLoading(true);
            setError(null);
            const data = await fetchData();
            setDocuments(data);
        } catch (err) {
            console.error("Failed to fetch documents", err);
            setError("אירעה שגיאה בטעינת המסמכים");
        } finally {
            setLoading(false);
        }
    }, [fetchData]);

    useEffect(() => {
        loadData();
    }, [refreshTrigger, fetchData]);

    const handleInternalDelete = async (id) => {
        if (window.confirm('האם אתה בטוח שברצונך למחוק מסמך זה?')) {
            try {
                await deleteFunc(id);
                setDocuments(prev => prev.filter(doc => doc.id !== id));
            } catch (err) {
                alert("שגיאה במחיקה");
            }
        }
    };

    const handleInternalAction = async (doc, actionFunc, isDownload = false) => {
        try {
            const url = await actionFunc(doc.id);

            if (!url) {
                alert('לא ניתן למצוא כתובת למסמך.');
                return;
            }

            if (isDownload) {
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', doc.original_name || '');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else {
                const fileName = doc.original_name || "";
                const ext = fileName.split('.').pop().toLowerCase();
                
                if (['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'].includes(ext)) {
                    const officeUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(url)}`;
                    window.open(officeUrl, '_blank');
                } else {
                    window.open(url, '_blank');
                }
            }
        } catch (err) {
            console.error('Action failed:', err);
            alert("הפעולה נכשלה");
        }
    };

    if (loading) return <p>טוען מסמכים...</p>;
    if (error) return <p className="error-message">{error}</p>;

    return (
        <div className="documents-container">
            <h2 className="documents-title">{title}</h2>
            {documents.length === 0 ? (
                <p>אין מסמכים להצגה</p>
            ) : (
                <table className="documents-table">
                    <thead>
                        <tr>
                            <th>שם קובץ</th>
                            <th>סוג</th>
                            <th>תאריך העלאה</th>
                            <th>תצוגה</th>
                            <th>הורדה</th>
                            <th></th> 
                        </tr>
                    </thead>
                    <tbody>
                        {documents.map((doc) => (
                            <tr key={doc.id}>
                                <td>{doc.original_name}</td>
                                <td>{doc.original_name?.split('.').pop() || 'לא ידוע'}</td>
                                <td>{new Date(doc.upload_date).toLocaleDateString()}</td>
                                <td>
                                    <a 
                                        href="#" 
                                        className="documents-link"
                                        onClick={(e) => { e.preventDefault(); handleInternalAction(doc, viewFunc); }}
                                    >
                                        לצפייה בקובץ
                                    </a>
                                </td>
                                <td>
                                    <a 
                                        href="#" 
                                        className="documents-link"
                                        onClick={(e) => { e.preventDefault(); handleInternalAction(doc, downloadFunc, true); }}
                                    >
                                        להורדת קובץ
                                    </a>
                                </td>
                                <td className="action-cell">
                                    <button
                                        className="icon-btn"
                                        onClick={() => handleInternalDelete(doc.id)}
                                        title="מחיקה"
                                    >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                        >
                                            <path d="M3 5.5H17M7 5.5V4C7 3.44772 7.44772 3 8 3H12C12.5523 3 13 3.44772 13 4V5.5M9 8.5V15.5M11 8.5V15.5M5 5.5H15L16 17C16 17.5523 15.5523 18 15 18H5C4.44772 18 4 17.5523 4 17L5 5.5Z" />
                                        </svg>
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default GenericDocument;